
import { Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { date as date_4, compare, now, toString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { Filter, Msg } from "./Types.js";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { curry3, equals, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { toArray, empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { RadioButton } from "../../Components/RadioButton.js";
import { Badge as Badge_1 } from "../../Components/Badge.js";
import { toArray as toArray_1, choose, singleton as singleton_1, exists, filter as filter_1, length, empty as empty_1, isEmpty, map, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { DatePicker } from "../../Components/DatePicker.js";
import { Select } from "../../Components/Select.js";
import { map as map_1, defaultArg, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { TextButton, Button } from "../../Components/Button.js";
import { allowsInAnyStorageOf, canBookInStorages, hasSelfServiceAccess as hasSelfServiceAccess_1, usePermissions } from "../../UserPermissions.js";
import { Permissions_has, Permission } from "../../Shared/Roles.js";
import { LabelInventoryKind, activeConfiguration } from "../../Shared/Label.js";
import { maxSelectedIds } from "../../Shared/MultiOperation.js";
import { toast } from "react-hot-toast";
import { OnTableRowClick$1, ActiveTableFilter, ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { SetId, ToolId, LabelId } from "../../Shared/Shared.js";
import { Label as Label_13 } from "../../Shared/Category.js";
import { RouterModule_encodeQueryString, RouterModule_nav, RouterModule_encodeParts } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { InventoryKind } from "../../Shared/InventoryStates.js";
import { defaultFilterNames, resolve, name as name_15 } from "../../InventoryStates/Display.js";
import { ofToolState } from "../../Shared/InventoryStateMapping.js";
import { Table_customPropertyColumnDefinitions } from "../../Widgets/CustomProperties.js";
import { MultiAssignModalSheet } from "../../Widgets/Modals/MultiAssignModal.js";
import { MultiUnassignModalSheet } from "../../Widgets/Modals/MultiUnassignModal.js";
import { MultiReservationModalSheet } from "../../Widgets/Modals/MultiReservationModal.js";
import { MultiReminderModalSheet } from "../../Widgets/Modals/MultiReminderModal.js";
import { MultiSwitchStorageModalSheet } from "../../Widgets/Modals/MultiSwitchStorageModal.js";
import { MultiChangeBusinessUnitModalSheet } from "../../Widgets/Modals/MultiChangeBusinessUnitModal.js";
import { printItem, logoUrlFor, PrintLabelsModalSheet } from "../../Labels/PrintLabelsDialog.js";
import { MultiUpdateStateModalSheet } from "../../Widgets/Modals/MultiUpdateStateModal.js";
import { TabsMenu } from "../../Widgets/TabsMenu.js";
import Shipment_Add from "../../../public/assets/icons/Shipment_Add.svg";
import { isSetBundlesTourOverviewPhase, isFilterSearchOnboardingTourTablePhase, isAssignToolsOnboardingTourTablePhase, getQueryParams, queryParamsForCreateInventoryTourForm, isCreateInventoryOnboardingTourOverviewPhase } from "../../Common.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { TableControlElement$1, TableControl$1 } from "../../Widgets/Table/Table.js";
import Following from "../../../public/assets/icons/Following.svg";
import Followers from "../../../public/assets/icons/Followers.svg";
import { InfiniteTable } from "../../Widgets/Table/InfiniteTable.js";
import { SWR_getTools } from "../../Requests/Tool.js";
import { SWR_getLabels } from "../../Requests/Category.js";
import { SWR_getStates } from "../../Requests/InventoryStates.js";
import { Skeleton } from "../../Components/Skeleton.js";
import { TourGuideLocale, TourStep, TourGuide } from "../../Components/TourGuide.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";

export class SelectedFilter extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["FreeInventorySelected", "ReservedInventorySelected", "NamedInventorySelected"];
    }
}

export function SelectedFilter_$reflection() {
    return union_type("Tools.Overview.View.SelectedFilter", [], SelectedFilter, () => [[], [], []]);
}

function dateRangeLabel(startDate, endDate) {
    return (toString(startDate, "dd.MM.yyyy") + " - ") + toString(endDate, "dd.MM.yyyy");
}

export function FilterElement(props) {
    let elems_12, elems_3, elems_8, elems_11, elems_14, elems_13;
    const t = useTranslation()[0];
    const dispatchEvent = (value) => {
        props.Dispatch(new Msg(0, [value]));
    };
    const patternInput_1 = reactApi.useState("");
    const setReservationNameValue = patternInput_1[1];
    const reservationNameValue = patternInput_1[0];
    let patternInput_2;
    const initial_1 = now();
    patternInput_2 = reactApi.useState(initial_1);
    const setFreeInventoryStartDate = patternInput_2[1];
    const freeInventoryStartDate = patternInput_2[0];
    let patternInput_3;
    const initial_2 = now();
    patternInput_3 = reactApi.useState(initial_2);
    const setFreeInventoryEndDate = patternInput_3[1];
    const freeInventoryEndDate = patternInput_3[0];
    let patternInput_4;
    const initial_3 = now();
    patternInput_4 = reactApi.useState(initial_3);
    const setReservedInventoryStartDate = patternInput_4[1];
    const reservedInventoryStartDate = patternInput_4[0];
    let patternInput_5;
    const initial_4 = now();
    patternInput_5 = reactApi.useState(initial_4);
    const setReservedInventoryEndDate = patternInput_5[1];
    const reservedInventoryEndDate = patternInput_5[0];
    let patternInput_6;
    let initial_5;
    const matchValue = props.SelectedFilter;
    initial_5 = ((matchValue == null) ? (new SelectedFilter(0, [])) : ((matchValue.tag === 0) ? (new SelectedFilter(1, [])) : ((matchValue.tag === 2) ? (new SelectedFilter(2, [])) : (new SelectedFilter(0, [])))));
    patternInput_6 = reactApi.useState(initial_5);
    const setSelectedFilter = patternInput_6[1];
    const selectedFilter = patternInput_6[0];
    reactApi.useEffect(() => {
        let matchValue_1;
        setSelectedFilter((matchValue_1 = props.SelectedFilter, (matchValue_1 == null) ? (new SelectedFilter(0, [])) : ((matchValue_1.tag === 0) ? (new SelectedFilter(1, [])) : ((matchValue_1.tag === 2) ? (new SelectedFilter(2, [])) : (new SelectedFilter(0, []))))));
    }, []);
    const xs_15 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3", "justify-items-stretch"])], (elems_12 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems_3 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-2"])], (elems = toList(delay(() => append(singleton(createElement(RadioButton, {
            ComponentState: "enabled",
            Label: t("tool.free_inventory"),
            OnSelect: (value_4) => {
                if (value_4) {
                    setSelectedFilter(new SelectedFilter(0, []));
                }
            },
            Selected: equals(selectedFilter, new SelectedFilter(0, [])),
        })), delay(() => {
            const matchValue_2 = props.SelectedFilter;
            let matchResult;
            if (matchValue_2 != null) {
                if (matchValue_2.tag === 1) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return singleton(createElement(Badge_1, {
                        Color: "#14BC9C",
                        Label: "1",
                        TestId: "1-badge-test-id",
                    }));
                default: {
                    return empty();
                }
            }
        })))), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_2;
            return equals(selectedFilter, new SelectedFilter(0, [])) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-5"])], (elems_2 = [createElement(DatePicker, {
                ComponentState: "enabled",
                IsClearable: false,
                OnChange: (date) => {
                    if (date != null) {
                        const value_7 = date;
                        if (compare(value_7, freeInventoryEndDate) > 0) {
                            setFreeInventoryEndDate(value_7);
                        }
                        setFreeInventoryStartDate(value_7);
                    }
                },
                TestId: "",
                Value: freeInventoryStartDate,
            }), reactElement("div", {
                className: join(" ", ["mt-2"]),
                children: reactApi.Children.toArray(["-"]),
            }), createElement(DatePicker, {
                ComponentState: "enabled",
                IsClearable: false,
                OnChange: (date_1) => {
                    if (date_1 != null) {
                        const value_11 = date_1;
                        if (compare(value_11, freeInventoryStartDate) < 0) {
                            setFreeInventoryStartDate(value_11);
                        }
                        setFreeInventoryEndDate(value_11);
                    }
                },
                TestId: "",
                Value: freeInventoryEndDate,
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems_8 = toList(delay(() => {
        let elems_4;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-2"])], (elems_4 = toList(delay(() => append(singleton(createElement(RadioButton, {
            ComponentState: "enabled",
            Label: t("tool.reserved_inventory"),
            OnSelect: (value_16) => {
                if (value_16) {
                    setSelectedFilter(new SelectedFilter(1, []));
                }
            },
            Selected: equals(selectedFilter, new SelectedFilter(1, [])),
        })), delay(() => {
            const matchValue_3 = props.SelectedFilter;
            let matchResult_1;
            if (matchValue_3 != null) {
                if (matchValue_3.tag === 0) {
                    matchResult_1 = 0;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return singleton(createElement(Badge_1, {
                        Color: "#14BC9C",
                        Label: "1",
                        TestId: "1-badge-test-id",
                    }));
                default: {
                    return empty();
                }
            }
        })))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
            let elems_7, elems_6;
            return equals(selectedFilter, new SelectedFilter(1, [])) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_7 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-5"])], (elems_6 = [createElement(DatePicker, {
                ComponentState: "enabled",
                IsClearable: false,
                OnChange: (date_2) => {
                    if (date_2 != null) {
                        const value_20 = date_2;
                        if (compare(value_20, reservedInventoryEndDate) > 0) {
                            setReservedInventoryEndDate(value_20);
                        }
                        setReservedInventoryStartDate(value_20);
                    }
                },
                TestId: "",
                Value: reservedInventoryStartDate,
            }), reactElement("div", {
                className: join(" ", ["mt-2"]),
                children: reactApi.Children.toArray(["-"]),
            }), createElement(DatePicker, {
                ComponentState: "enabled",
                IsClearable: false,
                OnChange: (date_3) => {
                    if (date_3 != null) {
                        const value_24 = date_3;
                        if (compare(value_24, reservedInventoryStartDate) < 0) {
                            setReservedInventoryStartDate(value_24);
                        }
                        setReservedInventoryEndDate(value_24);
                    }
                },
                TestId: "",
                Value: reservedInventoryEndDate,
            })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))) : empty();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_8))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems_11 = toList(delay(() => {
        let elems_9;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-2"])], (elems_9 = toList(delay(() => append(singleton(createElement(RadioButton, {
            ComponentState: "enabled",
            Label: t("tool.filter.reservation_name_text_filter"),
            OnSelect: (value_30) => {
                if (value_30) {
                    setSelectedFilter(new SelectedFilter(2, []));
                }
            },
            Selected: equals(selectedFilter, new SelectedFilter(2, [])),
        })), delay(() => {
            const matchValue_4 = props.SelectedFilter;
            let matchResult_2;
            if (matchValue_4 != null) {
                if (matchValue_4.tag === 2) {
                    matchResult_2 = 0;
                }
                else {
                    matchResult_2 = 1;
                }
            }
            else {
                matchResult_2 = 1;
            }
            switch (matchResult_2) {
                case 0:
                    return singleton(createElement(Badge_1, {
                        Color: "#14BC9C",
                        Label: "1",
                        TestId: "1-badge-test-id",
                    }));
                default: {
                    return empty();
                }
            }
        })))), ["children", reactApi.Children.toArray(Array.from(elems_9))])])))), delay(() => {
            let elems_10;
            return equals(selectedFilter, new SelectedFilter(2, [])) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_10 = [createElement(Select, {
                ComponentState: "enabled",
                IsClearable: true,
                NoOptionsMessage: "",
                OnChange: (value_33) => {
                    if (value_33 == null) {
                        setReservationNameValue("");
                    }
                    else {
                        setReservationNameValue(value_33.value);
                    }
                },
                Options: map((reservationName) => ({
                    label: reservationName,
                    value: reservationName,
                }), props.ReservationNames),
                PlaceholderKey: "",
                TestId: "",
                Value: unwrap((reservationNameValue !== "") ? {
                    label: reservationNameValue,
                    value: reservationNameValue,
                } : undefined),
            })], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))) : empty();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_11))])])))], ["children", reactApi.Children.toArray(Array.from(elems_12))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "w-[330px]", "mx-auto", "mt-2"])], (elems_14 = [createElement(Button, {
        ComponentState: "enabled",
        Label: t("tool.show_objects"),
        OnClick: () => {
            switch (selectedFilter.tag) {
                case 1: {
                    dispatchEvent(new Filter(0, [reservedInventoryStartDate, reservedInventoryEndDate]));
                    break;
                }
                case 2: {
                    dispatchEvent(new Filter(2, [reservationNameValue]));
                    break;
                }
                default:
                    dispatchEvent(new Filter(1, [freeInventoryStartDate, freeInventoryEndDate]));
            }
            props.OnClose();
        },
        TestId: "infinite-table-complex-filter-button",
        Variant: "primary",
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["mx-auto", "mt-1"])], (elems_13 = [createElement(TextButton, {
        ComponentState: "enabled",
        Label: t("tool.filter.reset_filter"),
        OnClick: () => {
            dispatchEvent(undefined);
            setReservationNameValue("");
            setFreeInventoryStartDate(now());
            setFreeInventoryEndDate(now());
            setReservedInventoryStartDate(now());
            setReservedInventoryEndDate(now());
            setSelectedFilter(new SelectedFilter(0, []));
            props.OnResetColumnFilters();
            props.OnClose();
        },
        TestId: "infinite-table-complex-filter-reset",
        Variant: "blueButton",
    })], ["children", reactApi.Children.toArray(Array.from(elems_13))])])))], ["children", reactApi.Children.toArray(Array.from(elems_14))])])))];
    return react.createElement(react.Fragment, {}, ...xs_15);
}

export function ToolsOverviewTable(props) {
    let elems_4;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const permissions = usePermissions();
    const hasSelfServiceAccess = hasSelfServiceAccess_1(props.CustomerConfiguration, props.UserData.UserId, props.Storages);
    const canAssign = canBookInStorages(permissions, new Permission(6, []), props.UserData.UserId, props.Storages, hasSelfServiceAccess);
    const canTakeBack = canBookInStorages(permissions, new Permission(7, []), props.UserData.UserId, props.Storages, hasSelfServiceAccess && props.CustomerConfiguration.IsStorageSelfServiceUserAuthorisedToReturnToolsWithoutNotification);
    const canChangeState = allowsInAnyStorageOf(permissions, new Permission(4, []), props.UserData.UserId, props.Storages);
    const canSwitchStorage = allowsInAnyStorageOf(permissions, new Permission(5, []), props.UserData.UserId, props.Storages);
    const canChangeBusinessUnit = (props.AccountSettings.BusinessUnitsEnabled && isEmpty(props.CurrentUser.BusinessUnitIds)) && Permissions_has(permissions, new Permission(9, []));
    const canCreateReservation = Permissions_has(permissions, new Permission(11, []));
    const canPrintLabels = (activeConfiguration(props.CustomerConfiguration) != null) && allowsInAnyStorageOf(permissions, new Permission(24, []), props.UserData.UserId, props.Storages);
    const canAssignPrintedCodes = allowsInAnyStorageOf(permissions, new Permission(22, []), props.UserData.UserId, props.Storages);
    const patternInput_1 = reactApi.useState([false, empty_1()]);
    const setIsPrintLabelsDialogOpen = patternInput_1[1];
    const isPrintLabelsDialogOpen = patternInput_1[0];
    const canCreateReminder = allowsInAnyStorageOf(permissions, new Permission(19, []), props.UserData.UserId, props.Storages);
    const patternInput_2 = reactApi.useState([false, [empty_1(), empty_1()]]);
    const isAssignModalSheetOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState([false, [empty_1(), empty_1()]]);
    const isUnassignModalSheetOpen = patternInput_3[0];
    const patternInput_4 = reactApi.useState([false, [empty_1(), empty_1()]]);
    const isMultipleReservationToolModalSheetOpen = patternInput_4[0];
    const patternInput_5 = reactApi.useState([false, [empty_1(), empty_1()]]);
    const isMultipleReminderToolModalSheetOpen = patternInput_5[0];
    const patternInput_6 = reactApi.useState([false, [empty_1(), empty_1()]]);
    const isSwitchStorageModalSheetOpen = patternInput_6[0];
    const patternInput_7 = reactApi.useState([false, [empty_1(), empty_1(), empty_1()]]);
    const isChangeStateModalSheetOpen = patternInput_7[0];
    const patternInput_8 = reactApi.useState([false, [empty_1(), empty_1()]]);
    const isChangeBusinessUnitModalSheetOpen = patternInput_8[0];
    const withinSelectionLimit = (selectedCount, setIsOpen, _arg) => {
        let arg_1;
        const selection = _arg[1];
        const isOpen = _arg[0];
        const count = selectedCount(selection) | 0;
        if (isOpen && (count > maxSelectedIds)) {
            toast.error((arg_1 = {
                count: count,
                max: maxSelectedIds,
            }, patternInput[1].t("multi_operation.too_many_elements", arg_1)));
        }
        else {
            setIsOpen([isOpen, selection]);
        }
    };
    const toolAndSetCount = (_arg_1) => ((length(_arg_1[0]) + length(_arg_1[1])) | 0);
    const setIsAssignModalSheetOpen_1 = curry3(withinSelectionLimit)(toolAndSetCount)(patternInput_2[1]);
    const setIsUnassignModalSheetOpen_1 = curry3(withinSelectionLimit)(toolAndSetCount)(patternInput_3[1]);
    const setIsMultipleReservationToolModalSheetOpen_1 = curry3(withinSelectionLimit)(toolAndSetCount)(patternInput_4[1]);
    const setIsMultipleReminderToolModalSheetOpen_1 = curry3(withinSelectionLimit)(toolAndSetCount)(patternInput_5[1]);
    const setIsSwitchStorageModalSheetOpen_1 = curry3(withinSelectionLimit)(toolAndSetCount)(patternInput_6[1]);
    const setIsChangeStateModalSheetOpen_1 = curry3(withinSelectionLimit)((_arg_2) => ((length(_arg_2[0]) + length(_arg_2[1])) | 0))(patternInput_7[1]);
    const setIsChangeBusinessUnitModalSheetOpen_1 = curry3(withinSelectionLimit)(toolAndSetCount)(patternInput_8[1]);
    let tools;
    const dependencies_1 = [props.Tools];
    tools = reactApi.useMemo(() => props.Tools, dependencies_1);
    let tools_1;
    const matchValue = props.State.SelectedFilter;
    if (matchValue != null) {
        const filter = matchValue;
        const isDateInRange = (startDate, endDate, reservationStartDate, reservationEndDate) => {
            if ((((compare(startDate, date_4(reservationStartDate)) >= 0) && (compare(endDate, date_4(reservationEndDate)) <= 0)) ? true : (((compare(startDate, date_4(reservationStartDate)) >= 0) && (compare(startDate, date_4(reservationEndDate)) <= 0)) && (compare(endDate, date_4(reservationEndDate)) >= 0))) ? true : ((compare(startDate, date_4(reservationStartDate)) <= 0) && ((compare(endDate, date_4(reservationStartDate)) >= 0) && (compare(endDate, date_4(reservationEndDate)) <= 0)))) {
                return true;
            }
            else if (compare(startDate, date_4(reservationStartDate)) <= 0) {
                return compare(endDate, date_4(reservationEndDate)) >= 0;
            }
            else {
                return false;
            }
        };
        switch (filter.tag) {
            case 0: {
                tools_1 = filter_1((tool_1) => exists((r_3) => isDateInRange(filter.fields[0], filter.fields[1], r_3.StartDate, r_3.EndDate), tool_1.Reservations), props.Tools);
                break;
            }
            case 2: {
                tools_1 = filter_1((tool_2) => exists((r_4) => (r_4.Name === filter.fields[0]), tool_2.Reservations), props.Tools);
                break;
            }
            default: {
                const startDate_1 = filter.fields[0];
                const endDate_1 = filter.fields[1];
                tools_1 = filter_1((tool) => !(exists((r) => isDateInRange(startDate_1, endDate_1, r.StartDate, r.EndDate), tool.Reservations) ? true : exists((r_2) => {
                    if (compare(startDate_1, r_2.Date) <= 0) {
                        return compare(endDate_1, r_2.Date) >= 0;
                    }
                    else {
                        return false;
                    }
                }, filter_1((r_1) => !r_1.IsConfirmed, tool.Reminders))), props.Tools);
            }
        }
    }
    else {
        tools_1 = tools;
    }
    let columnDefinition;
    const dependencies_1_1 = [props.Definitions, props.PropertyConfigurations, props.CustomerConfiguration, props.AccountSettings, props.State.Customer];
    columnDefinition = reactApi.useMemo(() => toArray(delay(() => append(singleton(new ColumnDefinition$1("image", t("general.master_data"), t("general.image"), (dto) => (new CellContent(7, [map((image) => ({
        ImageUrl: image.ImageUrl,
        Position: image.Position,
    }), dto.ToolImages)])), "none", "image")), delay(() => append(singleton(new ColumnDefinition$1("manufacturer", t("general.master_data"), t("tool.manufacturer"), (dto_1) => (new CellContent(0, [dto_1.Manufacturer])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("model", t("general.master_data"), t("tool.model"), (dto_2) => (new CellContent(0, [dto_2.Model])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("displayName", t("general.master_data"), t("tool.displayname"), (dto_3) => (new CellContent(0, [dto_3.DisplayName])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("inventoryNumber", t("general.master_data"), t("tool.inventory_number"), (dto_4) => (new CellContent(0, [dto_4.InventoryNumber])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("serialNumber", t("general.master_data"), t("tool.serial_number"), (dto_5) => (new CellContent(0, [dto_5.SerialNumber])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("label", t("general.master_data"), t("tool.label"), (dto_6) => (new CellContent(4, [dto_6.Labels])), "categorySelect", "text")), delay(() => append((props.State.Customer.tag === 1) ? singleton(new ColumnDefinition$1("checkNumber", t("general.master_data"), t("tool.prinzing.check_number"), (dto_7) => (new CellContent(0, [dto_7.CheckNumber])), "text", "text")) : (empty()), delay(() => append(singleton(new ColumnDefinition$1("comment", t("general.master_data"), t("general.comment"), (dto_8) => (new CellContent(0, [dto_8.Comment])), "text", "text")), delay(() => append(props.CustomerConfiguration.IsReleaseDateEnabled ? singleton(new ColumnDefinition$1("releaseDate", t("general.master_data"), t("general.release_date"), (dto_9) => (new CellContent(8, [dto_9.ReleaseDate])), "dateRange", "date")) : empty(), delay(() => append(singleton(new ColumnDefinition$1("lastInspectionDate", t("general.master_data"), t("tool.last_check"), (dto_10) => (new CellContent(8, [dto_10.LastInspectionDate])), "dateRange", "date")), delay(() => append(singleton(new ColumnDefinition$1("nextInspectionDate", t("general.master_data"), t("tool.next_inspection"), (dto_11) => (new CellContent(8, [dto_11.NextInspectionDate])), "dateRange", "date")), delay(() => append((props.AccountSettings.InspectionsEnabled && isFeatureEnabled(new Feature(21, []))) ? append(singleton(new ColumnDefinition$1("latestInspectionResultDate", t("tool.inspection_group"), t("tool.latest_inspection_result_date"), (dto_12) => (new CellContent(8, [dto_12.LatestInspectionResultDate])), "dateRange", "date")), delay(() => append(singleton(new ColumnDefinition$1("nextScheduledInspectionDate", t("tool.inspection_group"), t("tool.next_scheduled_inspection"), (dto_13) => (new CellContent(8, [dto_13.NextScheduledInspectionDate])), "dateRange", "date")), delay(() => singleton(new ColumnDefinition$1("inspectionStatus", t("tool.inspection_group"), t("toolbox.inspection_status"), (dto_14) => {
        const matchValue_2 = dto_14.InspectionStatus;
        return (matchValue_2 == null) ? (new CellContent(0, [""])) : ((matchValue_2.tag === 1) ? (new CellContent(4, [singleton_1(new Label_13(new LabelId("00000000-0000-0000-0000-000000000000"), t("toolbox.inspection_status_expired"), "#fd7e14", true, undefined))])) : ((matchValue_2.tag === 2) ? (new CellContent(4, [singleton_1(new Label_13(new LabelId("00000000-0000-0000-0000-000000000000"), t("toolbox.inspection_status_failed"), "#dc3545", true, undefined))])) : ((matchValue_2.tag === 3) ? (new CellContent(4, [singleton_1(new Label_13(new LabelId("00000000-0000-0000-0000-000000000000"), t("toolbox.inspection_status_never_inspected"), "#dc3545", true, undefined))])) : (new CellContent(4, [singleton_1(new Label_13(new LabelId("00000000-0000-0000-0000-000000000000"), t("toolbox.inspection_status_ok"), "#28a745", true, undefined))])))));
    }, "select", "text")))))) : empty(), delay(() => append(singleton(new ColumnDefinition$1("lastHistoryComment", t("general.master_data"), t("general.last_history_comment"), (dto_15) => (new CellContent(0, [t(dto_15.LastHistoryComment)])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("nextReminderDate", t("general.master_data"), t("tool.next_check"), (dto_16) => (new CellContent(8, [dto_16.NextReminderDate])), "dateRange", "date")), delay(() => append(singleton(new ColumnDefinition$1("nextReservationDate", t("general.master_data"), t("tool.next_reservation"), (dto_17) => (new CellContent(8, [dto_17.NextReservationDate])), "dateRange", "date")), delay(() => append(props.AccountSettings.BusinessUnitsEnabled ? singleton(new ColumnDefinition$1("businessUnit", t("general.master_data"), t("business_units.business_unit"), (dto_18) => (new CellContent(0, [dto_18.BusinessUnitName])), "select", "text")) : empty(), delay(() => append(singleton(new ColumnDefinition$1("location", t("general.master_data"), t("general.location"), (dto_19) => (new CellContent(0, [dto_19.Location])), "locationSelect", "text")), delay(() => append(singleton(new ColumnDefinition$1("storage", t("general.master_data"), t("general.storage"), (dto_20) => (new CellContent(0, [dto_20.Storage])), "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("storageSpace", t("general.master_data"), t("tool.storage_space"), (dto_21) => (new CellContent(0, [dto_21.StorageSpace])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("isPartOfSet", t("general.master_data"), t("general.part_of_set"), (dto_22) => (new CellContent(0, [(dto_22.SetId != null) ? t("general.yes") : t("general.no")])), "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("setName", t("general.master_data"), t("general.set"), (dto_23) => {
        const matchValue_3 = dto_23.SetId;
        const matchValue_4 = dto_23.SetName;
        let matchResult, setId, setName;
        if (matchValue_3 != null) {
            if (matchValue_4 != null) {
                matchResult = 0;
                setId = matchValue_3;
                setName = matchValue_4;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return new CellContent(1, [setName, RouterModule_encodeParts(ofArray(["sets", setId]), 1)]);
            default:
                return new CellContent(0, [""]);
        }
    }, "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("stockQuantity", t("general.master_data"), t("general.stock"), (dto_24) => (new CellContent(0, [defaultArg(dto_24.StockQuantity, "")])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("minimumStockQuantity", t("general.master_data"), t("dashboard.minimum_stock"), (dto_25) => (new CellContent(0, [defaultArg(dto_25.MinimumStockQuantity, "")])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("qrCodeIds", t("general.master_data"), t("general.qr_code"), (dto_26) => (new CellContent(0, [dto_26.QRCodeIds])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("currentLocation", t("general.master_data"), t("tool.assgined_to"), (dto_27) => (new CellContent(0, [t(dto_27.CurrentLocation)])), "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("isToolWithQuantity", t("general.master_data"), t("general.tool_type"), (dto_28) => {
        let matchValue_6;
        return new CellContent(5, [(matchValue_6 = dto_28.ToolOverviewType, (matchValue_6 === "toolWithQuantity") ? (new InventoryKind(2, [])) : ((matchValue_6 === "set") ? (new InventoryKind(1, [])) : (new InventoryKind(0, []))))]);
    }, "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("state", t("general.master_data"), t("general.state"), (dto_29) => (new CellContent(0, [name_15(t, resolve(props.Definitions, dto_29.StateKey, ofToolState(dto_29.State)))])), "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("supplierArticleNumber", t("tool.commercial_data"), t("general.supplier_article_number"), (dto_30) => (new CellContent(0, [dto_30.SupplierArticleNumber])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("supplier", t("tool.commercial_data"), t("general.supplier"), (dto_31) => (new CellContent(0, [dto_31.Supplier])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("purchaseDate", t("tool.commercial_data"), t("general.purchase_date"), (dto_32) => (new CellContent(8, [dto_32.PurchaseDate])), "dateRange", "date")), delay(() => append(singleton(new ColumnDefinition$1("guranteeDate", t("tool.commercial_data"), t("general.gurantee_date"), (dto_33) => (new CellContent(8, [dto_33.WarrantyDate])), "dateRange", "date")), delay(() => append(singleton(new ColumnDefinition$1("purchasePrice", t("tool.commercial_data"), t("general.purchase_price"), (dto_34) => (new CellContent(0, [dto_34.PurchasePrice])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("lastSeen", t("general.master_data"), t("general.last_seen"), (dto_35) => (new CellContent(8, [dto_35.LastSeen])), "dateRange", "date")), delay(() => Table_customPropertyColumnDefinitions(props.PropertyConfigurations, t("tool.custom_properties"), (dto_36) => dto_36.CustomProperties, t, props.CustomerConfiguration.Currency))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))), dependencies_1_1);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "flex-col"])], (elems_4 = toList(delay(() => append(singleton(createElement(MultiAssignModalSheet, {
        AssignProps: {
            ConsumableIds: empty_1(),
            SetIds: isAssignModalSheetOpen[1][1],
            ToolIds: isAssignModalSheetOpen[1][0],
        },
        CustomerConfiguration: props.CustomerConfiguration,
        IsOpen: isAssignModalSheetOpen[0],
        OnClose: () => {
            setIsAssignModalSheetOpen_1([false, [empty_1(), empty_1()]]);
        },
        PredefinedQuantities: empty_1(),
        SuccessCallback: props.CallMutate,
        UserData: props.UserData,
    })), delay(() => append(singleton(createElement(MultiUnassignModalSheet, {
        AllowStorageChange: true,
        CustomerConfiguration: props.CustomerConfiguration,
        IsOpen: isUnassignModalSheetOpen[0],
        OnClose: () => {
            setIsUnassignModalSheetOpen_1([false, [empty_1(), empty_1()]]);
        },
        SuccessCallback: props.CallMutate,
        UnassignProps: {
            ConsumableIds: empty_1(),
            SetIds: isUnassignModalSheetOpen[1][1],
            ToolIds: isUnassignModalSheetOpen[1][0],
        },
        UserData: props.UserData,
    })), delay(() => append(singleton(createElement(MultiReservationModalSheet, {
        CustomerConfiguration: props.CustomerConfiguration,
        IsOpen: isMultipleReservationToolModalSheetOpen[0],
        OnClose: () => {
            setIsMultipleReservationToolModalSheetOpen_1([false, [empty_1(), empty_1()]]);
        },
        ReservationProps: {
            ConsumableIds: empty_1(),
            SetIds: isMultipleReservationToolModalSheetOpen[1][1],
            ToolIds: isMultipleReservationToolModalSheetOpen[1][0],
        },
        SuccessCallback: props.CallMutate,
        UserData: props.UserData,
    })), delay(() => append(singleton(createElement(MultiReminderModalSheet, {
        CustomerConfiguration: props.CustomerConfiguration,
        IsOpen: isMultipleReminderToolModalSheetOpen[0],
        OnClose: () => {
            setIsMultipleReminderToolModalSheetOpen_1([false, [empty_1(), empty_1()]]);
        },
        ReminderProps: {
            ConsumableIds: empty_1(),
            SetIds: isMultipleReminderToolModalSheetOpen[1][1],
            ToolIds: isMultipleReminderToolModalSheetOpen[1][0],
        },
        SuccessCallback: props.CallMutate,
        UserData: props.UserData,
    })), delay(() => append(singleton(createElement(MultiSwitchStorageModalSheet, {
        IsOpen: isSwitchStorageModalSheetOpen[0],
        OnClose: () => {
            setIsSwitchStorageModalSheetOpen_1([false, [empty_1(), empty_1()]]);
        },
        SuccessCallback: props.CallMutate,
        ToolProps: {
            SetIds: isSwitchStorageModalSheetOpen[1][1],
            ToolIds: isSwitchStorageModalSheetOpen[1][0],
        },
        UserData: props.UserData,
    })), delay(() => append((props.AccountSettings.BusinessUnitsEnabled && Permissions_has(permissions, new Permission(9, []))) ? singleton(createElement(MultiChangeBusinessUnitModalSheet, {
        IsOpen: isChangeBusinessUnitModalSheetOpen[0],
        OnClose: () => {
            setIsChangeBusinessUnitModalSheetOpen_1([false, [empty_1(), empty_1()]]);
        },
        SuccessCallback: props.CallMutate,
        ToolProps: {
            SetIds: isChangeBusinessUnitModalSheetOpen[1][1],
            ToolIds: isChangeBusinessUnitModalSheetOpen[1][0],
        },
        UserData: props.UserData,
    })) : empty(), delay(() => {
        let matchValue_7, labelConfiguration, labelConfiguration_1;
        return append((matchValue_7 = activeConfiguration(props.CustomerConfiguration), (matchValue_7 != null) ? (((labelConfiguration = matchValue_7, isPrintLabelsDialogOpen[0])) ? ((labelConfiguration_1 = matchValue_7, singleton(createElement(PrintLabelsModalSheet, {
            CanAssignCodes: canAssignPrintedCodes,
            Configuration: labelConfiguration_1,
            IsOpen: isPrintLabelsDialogOpen[0],
            Items: isPrintLabelsDialogOpen[1],
            LogoUrl: unwrap(logoUrlFor(props.CustomerConfiguration)),
            OnClose: () => {
                setIsPrintLabelsDialogOpen([false, empty_1()]);
            },
            OnPrinted: props.CallMutate,
        })))) : (empty())) : (empty())), delay(() => append(singleton(createElement(MultiUpdateStateModalSheet, {
            AccountSettings: props.AccountSettings,
            IsOpen: isChangeStateModalSheetOpen[0],
            OnClose: () => {
                setIsChangeStateModalSheetOpen_1([false, [empty_1(), empty_1(), empty_1()]]);
            },
            SuccessCallback: () => {
                props.CallMutate();
                props.MutateDefinitions();
            },
            ToolProps: {
                SetIds: isChangeStateModalSheetOpen[1][1],
                StateKeys: isChangeStateModalSheetOpen[1][2],
                ToolIds: isChangeStateModalSheetOpen[1][0],
            },
            UserData: props.UserData,
        })), delay(() => {
            let elems_2;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-y-2", "pb-2", "shrink-0"])], (elems_2 = toList(delay(() => {
                let elems;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-4"])], (elems = [createElement(TabsMenu, {
                    Tabs: ofArray([{
                        IsSelected: true,
                        Label: t("general.tool"),
                        OnClick: () => {
                            RouterModule_nav(ofArray(["tools"]), 1, 1);
                        },
                        TestId: "overview-tab-tools",
                    }, {
                        IsSelected: false,
                        Label: t("general.consumable"),
                        OnClick: () => {
                            RouterModule_nav(ofArray(["consumables"]), 1, 1);
                        },
                        TestId: "overview-tab-consumables",
                    }]),
                })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append(singleton(reactElement("div", {
                    className: join(" ", ["grow"]),
                })), delay(() => {
                    let elems_1;
                    return allowsInAnyStorageOf(permissions, new Permission(1, []), props.UserData.UserId, props.Storages) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-3", "shrink-0"])], (elems_1 = toList(delay(() => {
                        let Label_2;
                        return append(singleton(createElement(Button, (Label_2 = t("tool.create_new_tool"), {
                            ComponentState: "enabled",
                            Icon: Shipment_Add(),
                            Label: Label_2,
                            OnClick: () => {
                                if (isCreateInventoryOnboardingTourOverviewPhase()) {
                                    RouterModule_nav(ofArray(["tools", "new" + RouterModule_encodeQueryString(queryParamsForCreateInventoryTourForm())]), 1, 1);
                                }
                                else {
                                    RouterModule_nav(ofArray(["tools", "new" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
                                }
                            },
                            TestId: "add-new-inventory-button",
                            Variant: "primary",
                        }))), delay(() => {
                            let Label_3;
                            return append(singleton(createElement(Button, (Label_3 = t("tool.create_new_simple_tool"), {
                                ComponentState: "enabled",
                                Icon: Shipment_Add(),
                                Label: Label_3,
                                OnClick: () => {
                                    RouterModule_nav(ofArray(["toolswithquantity", "new" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
                                },
                                TestId: "add-new-mass-inventory-button",
                                Variant: "primary",
                            }))), delay(() => {
                                let Label_4;
                                return props.AccountSettings.SetsEnabled ? singleton(createElement(Button, (Label_4 = t("set.overview.create_new_set"), {
                                    ComponentState: "enabled",
                                    Icon: Shipment_Add(),
                                    Label: Label_4,
                                    OnClick: () => {
                                        RouterModule_nav(ofArray(["sets", "new" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
                                    },
                                    TestId: "add-new-set-button",
                                    Variant: "primary",
                                }))) : empty();
                            }));
                        }));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty();
                }))));
            })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                let elems_3, TableRows, FilterDropDownElements, Badge, matchValue_16, endDate_4, startDate_4, reservationName, endDate_3, startDate_3, Options;
                const reserveAction = new TableControl$1(t("general.reserve"), undefined, (selectedTools) => {
                    if (isEmpty(selectedTools)) {
                    }
                    else {
                        const selectedIds = choose((selectedTool) => {
                            const matchValue_8 = selectedTool.ToolOverviewType;
                            switch (matchValue_8) {
                                case "toolWithQuantity":
                                    return [selectedTool.ToolOverviewType, selectedTool.Id];
                                case "set":
                                    return [selectedTool.ToolOverviewType, selectedTool.Id];
                                default:
                                    return [selectedTool.ToolOverviewType, selectedTool.Id];
                            }
                        }, selectedTools);
                        setIsMultipleReservationToolModalSheetOpen_1([true, [choose((tupledArg_15) => {
                            const selectedType = tupledArg_15[0];
                            const id = tupledArg_15[1];
                            switch (selectedType) {
                                case "toolWithQuantity":
                                    return new ToolId(parse(id));
                                case "set":
                                    return undefined;
                                default:
                                    return new ToolId(parse(id));
                            }
                        }, selectedIds), choose((tupledArg_16) => {
                            const selectedType_1 = tupledArg_16[0];
                            switch (selectedType_1) {
                                case "set":
                                    return new SetId(parse(tupledArg_16[1]));
                                default:
                                    return undefined;
                            }
                        }, selectedIds)]]);
                    }
                }, true, false, "tools-overview-reserve-action");
                const reminderAction = new TableControl$1(t("dialog.reminder.btn_title"), undefined, (selectedTools_1) => {
                    if (isEmpty(selectedTools_1)) {
                    }
                    else {
                        const selectedIds_1 = choose((selectedTool_1) => {
                            const matchValue_9 = selectedTool_1.ToolOverviewType;
                            switch (matchValue_9) {
                                case "toolWithQuantity":
                                    return [selectedTool_1.ToolOverviewType, selectedTool_1.Id];
                                case "set":
                                    return [selectedTool_1.ToolOverviewType, selectedTool_1.Id];
                                default:
                                    return [selectedTool_1.ToolOverviewType, selectedTool_1.Id];
                            }
                        }, selectedTools_1);
                        setIsMultipleReminderToolModalSheetOpen_1([true, [choose((tupledArg_17) => {
                            const selectedType_2 = tupledArg_17[0];
                            const id_2 = tupledArg_17[1];
                            switch (selectedType_2) {
                                case "toolWithQuantity":
                                    return new ToolId(parse(id_2));
                                case "set":
                                    return undefined;
                                default:
                                    return new ToolId(parse(id_2));
                            }
                        }, selectedIds_1), choose((tupledArg_18) => {
                            const selectedType_3 = tupledArg_18[0];
                            switch (selectedType_3) {
                                case "set":
                                    return new SetId(parse(tupledArg_18[1]));
                                default:
                                    return undefined;
                            }
                        }, selectedIds_1)]]);
                    }
                }, true, false, "tools-overview-reminder-action");
                const assignAction = new TableControlElement$1(0, [new TableControl$1(t("general.assign"), Following(), (selectedTools_2) => {
                    if (isEmpty(selectedTools_2)) {
                    }
                    else {
                        const selectedIds_2 = choose((selectedTool_2) => {
                            const matchValue_10 = selectedTool_2.ToolOverviewType;
                            switch (matchValue_10) {
                                case "toolWithQuantity":
                                    return [selectedTool_2.ToolOverviewType, selectedTool_2.Id];
                                case "set":
                                    return [selectedTool_2.ToolOverviewType, selectedTool_2.Id];
                                default:
                                    return [selectedTool_2.ToolOverviewType, selectedTool_2.Id];
                            }
                        }, selectedTools_2);
                        setIsAssignModalSheetOpen_1([true, [choose((tupledArg_19) => {
                            const selectedType_4 = tupledArg_19[0];
                            const id_4 = tupledArg_19[1];
                            switch (selectedType_4) {
                                case "toolWithQuantity":
                                    return new ToolId(parse(id_4));
                                case "set":
                                    return undefined;
                                default:
                                    return new ToolId(parse(id_4));
                            }
                        }, selectedIds_2), choose((tupledArg_20) => {
                            const selectedType_5 = tupledArg_20[0];
                            switch (selectedType_5) {
                                case "set":
                                    return new SetId(parse(tupledArg_20[1]));
                                default:
                                    return undefined;
                            }
                        }, selectedIds_2)]]);
                    }
                }, true, false, "tools-overview-assign-action")]);
                const takeBackAction = new TableControlElement$1(0, [new TableControl$1(t("general.take_back"), Followers(), (selectedTools_3) => {
                    if (isEmpty(selectedTools_3)) {
                    }
                    else {
                        const selectedIds_3 = choose((selectedTool_3) => {
                            const matchValue_11 = selectedTool_3.ToolOverviewType;
                            switch (matchValue_11) {
                                case "toolWithQuantity":
                                    return [selectedTool_3.ToolOverviewType, selectedTool_3.Id];
                                case "set":
                                    return [selectedTool_3.ToolOverviewType, selectedTool_3.Id];
                                default:
                                    return [selectedTool_3.ToolOverviewType, selectedTool_3.Id];
                            }
                        }, selectedTools_3);
                        setIsUnassignModalSheetOpen_1([true, [choose((tupledArg_21) => {
                            const selectedType_6 = tupledArg_21[0];
                            const id_6 = tupledArg_21[1];
                            switch (selectedType_6) {
                                case "toolWithQuantity":
                                    return new ToolId(parse(id_6));
                                case "set":
                                    return undefined;
                                default:
                                    return new ToolId(parse(id_6));
                            }
                        }, selectedIds_3), choose((tupledArg_22) => {
                            const selectedType_7 = tupledArg_22[0];
                            switch (selectedType_7) {
                                case "set":
                                    return new SetId(parse(tupledArg_22[1]));
                                default:
                                    return undefined;
                            }
                        }, selectedIds_3)]]);
                    }
                }, true, false, "tools-overview-take-back-action")]);
                const switchStorageAction = new TableControl$1(t("tool.switch_storage"), undefined, (selectedTools_4) => {
                    if (isEmpty(selectedTools_4)) {
                    }
                    else {
                        const selectedIds_4 = choose((selectedTool_4) => {
                            const matchValue_12 = selectedTool_4.ToolOverviewType;
                            switch (matchValue_12) {
                                case "toolWithQuantity":
                                    return [selectedTool_4.ToolOverviewType, selectedTool_4.Id];
                                case "set":
                                    return [selectedTool_4.ToolOverviewType, selectedTool_4.Id];
                                default:
                                    return [selectedTool_4.ToolOverviewType, selectedTool_4.Id];
                            }
                        }, selectedTools_4);
                        setIsSwitchStorageModalSheetOpen_1([true, [choose((tupledArg_23) => {
                            const selectedType_8 = tupledArg_23[0];
                            const id_8 = tupledArg_23[1];
                            switch (selectedType_8) {
                                case "toolWithQuantity":
                                    return new ToolId(parse(id_8));
                                case "set":
                                    return undefined;
                                default:
                                    return new ToolId(parse(id_8));
                            }
                        }, selectedIds_4), choose((tupledArg_24) => {
                            const selectedType_9 = tupledArg_24[0];
                            switch (selectedType_9) {
                                case "set":
                                    return new SetId(parse(tupledArg_24[1]));
                                default:
                                    return undefined;
                            }
                        }, selectedIds_4)]]);
                    }
                }, true, false, "tools-overview-switch-storage-action");
                const changeStateAction = new TableControl$1(t("multi_operation.change_state.new_state"), undefined, (selectedTools_5) => {
                    if (isEmpty(selectedTools_5)) {
                    }
                    else {
                        const selectedIds_5 = choose((selectedTool_5) => {
                            const matchValue_13 = selectedTool_5.ToolOverviewType;
                            switch (matchValue_13) {
                                case "toolWithQuantity":
                                    return [selectedTool_5.ToolOverviewType, selectedTool_5.Id];
                                case "set":
                                    return [selectedTool_5.ToolOverviewType, selectedTool_5.Id];
                                default:
                                    return [selectedTool_5.ToolOverviewType, selectedTool_5.Id];
                            }
                        }, selectedTools_5);
                        setIsChangeStateModalSheetOpen_1([true, [choose((tupledArg_25) => {
                            const selectedType_10 = tupledArg_25[0];
                            const id_10 = tupledArg_25[1];
                            switch (selectedType_10) {
                                case "toolWithQuantity":
                                    return new ToolId(parse(id_10));
                                case "set":
                                    return undefined;
                                default:
                                    return new ToolId(parse(id_10));
                            }
                        }, selectedIds_5), choose((tupledArg_26) => {
                            const selectedType_11 = tupledArg_26[0];
                            switch (selectedType_11) {
                                case "set":
                                    return new SetId(parse(tupledArg_26[1]));
                                default:
                                    return undefined;
                            }
                        }, selectedIds_5), map((selectedTool_6) => [selectedTool_6.Id, selectedTool_6.StateKey], selectedTools_5)]]);
                    }
                }, true, false, "tools-overview-change-state-action");
                const changeBusinessUnitAction = new TableControl$1(t("multi_operation.change_business_unit.title"), undefined, (selectedTools_6) => {
                    if (isEmpty(selectedTools_6)) {
                    }
                    else {
                        const selectedIds_6 = choose((selectedTool_7) => {
                            const matchValue_14 = selectedTool_7.ToolOverviewType;
                            switch (matchValue_14) {
                                case "toolWithQuantity":
                                    return [selectedTool_7.ToolOverviewType, selectedTool_7.Id];
                                case "set":
                                    return [selectedTool_7.ToolOverviewType, selectedTool_7.Id];
                                default:
                                    return [selectedTool_7.ToolOverviewType, selectedTool_7.Id];
                            }
                        }, selectedTools_6);
                        setIsChangeBusinessUnitModalSheetOpen_1([true, [choose((tupledArg_27) => {
                            const selectedType_12 = tupledArg_27[0];
                            const id_12 = tupledArg_27[1];
                            switch (selectedType_12) {
                                case "toolWithQuantity":
                                    return new ToolId(parse(id_12));
                                case "set":
                                    return undefined;
                                default:
                                    return new ToolId(parse(id_12));
                            }
                        }, selectedIds_6), choose((tupledArg_28) => {
                            const selectedType_13 = tupledArg_28[0];
                            switch (selectedType_13) {
                                case "set":
                                    return new SetId(parse(tupledArg_28[1]));
                                default:
                                    return undefined;
                            }
                        }, selectedIds_6)]]);
                    }
                }, true, false, "tools-overview-change-business-unit-action");
                const printLabelsAction = new TableControl$1(t("labels.print.action_multiple"), undefined, (selectedTools_7) => {
                    if (isEmpty(selectedTools_7)) {
                    }
                    else {
                        setIsPrintLabelsDialogOpen([true, map((selectedTool_8) => {
                            const matchValue_15 = selectedTool_8.ToolOverviewType;
                            switch (matchValue_15) {
                                case "toolWithQuantity":
                                    return printItem(new LabelInventoryKind(2, []), selectedTool_8.Id);
                                case "set":
                                    return printItem(new LabelInventoryKind(1, []), selectedTool_8.Id);
                                default:
                                    return printItem(new LabelInventoryKind(0, []), selectedTool_8.Id);
                            }
                        }, selectedTools_7)]);
                    }
                }, true, false, "tools-overview-print-labels-action");
                return singleton(reactElement("div", createObj(ofArray([["data-test-id", "tools-overview-inventory-table"], ["className", join(" ", ["flex-1", "min-h-0", "[&>div]:h-full"])], (elems_3 = [createElement(InfiniteTable, (TableRows = toArray_1(tools_1), (FilterDropDownElements = ((Badge = map_1((_arg_37) => "1", props.State.SelectedFilter), {
                    ActiveFilters: (matchValue_16 = props.State.SelectedFilter, (matchValue_16 == null) ? empty_1() : ((matchValue_16.tag === 0) ? ((endDate_4 = matchValue_16.fields[1], (startDate_4 = matchValue_16.fields[0], singleton_1(new ActiveTableFilter("reserved-inventory", t("tool.reserved_inventory"), dateRangeLabel(startDate_4, endDate_4), () => {
                        props.Dispatch(new Msg(0, [undefined]));
                    }))))) : ((matchValue_16.tag === 2) ? ((reservationName = matchValue_16.fields[0], singleton_1(new ActiveTableFilter("reservation-name", t("tool.filter.reservation_name_label"), reservationName, () => {
                        props.Dispatch(new Msg(0, [undefined]));
                    })))) : ((endDate_3 = matchValue_16.fields[1], (startDate_3 = matchValue_16.fields[0], singleton_1(new ActiveTableFilter("free-inventory", t("tool.free_inventory"), dateRangeLabel(startDate_3, endDate_3), () => {
                        props.Dispatch(new Msg(0, [undefined]));
                    })))))))),
                    Badge: unwrap(Badge),
                    Content: (context) => createElement(FilterElement, {
                        Dispatch: props.Dispatch,
                        OnClose: context.OnClose,
                        OnResetColumnFilters: context.ResetColumnFilters,
                        ReservationNames: props.ReservationNames,
                        SelectedFilter: unwrap(props.State.SelectedFilter),
                    }),
                })), (Options = {
                    BorderStyle: "full",
                    CSVDownload: true,
                    ConfigurableColumns: true,
                    CustomTableFilters: true,
                    DefaultColumnFilter: singleton_1({
                        id: "state",
                        value: defaultFilterNames(t, ofArray([new InventoryKind(0, []), new InventoryKind(2, []), new InventoryKind(1, [])]), props.Definitions),
                    }),
                    DefaultSortColumn: ["manufacturer", "asc"],
                    Fullscreen: true,
                    GlobalSearch: true,
                    OnRowClick: new OnTableRowClick$1(1, [(dto_37) => {
                        let matchValue_17;
                        return RouterModule_encodeParts(ofArray([(matchValue_17 = dto_37.ToolOverviewType, (matchValue_17 === "toolWithQuantity") ? "toolswithquantity" : ((matchValue_17 === "set") ? "sets" : "tools")), dto_37.Id + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1);
                    }]),
                    RowSelection: "multiRow",
                    SaveTableConfiguration: true,
                    WithQueryParameters: true,
                }, {
                    ColumnDefinitions: columnDefinition,
                    Controls: toList(delay(() => append(canAssign ? singleton(assignAction) : empty(), delay(() => append(canTakeBack ? singleton(takeBackAction) : empty(), delay(() => {
                        const planningActions = toList(delay(() => append(canCreateReservation ? singleton(reserveAction) : empty(), delay(() => (canCreateReminder ? singleton(reminderAction) : empty())))));
                        return append(!isEmpty(planningActions) ? singleton(new TableControlElement$1(1, [t("table.planning"), "tools-overview-planning-actions", planningActions])) : empty(), delay(() => {
                            const moreActions = toList(delay(() => append(canChangeState ? singleton(changeStateAction) : empty(), delay(() => append(canSwitchStorage ? singleton(switchStorageAction) : empty(), delay(() => append(canChangeBusinessUnit ? singleton(changeBusinessUnitAction) : empty(), delay(() => (canPrintLabels ? singleton(printLabelsAction) : empty())))))))));
                            return !isEmpty(moreActions) ? singleton(new TableControlElement$1(1, [t("table.more"), "tools-overview-more-actions", moreActions])) : empty();
                        }));
                    })))))),
                    FilterDropDownElements: unwrap(FilterDropDownElements),
                    Options: Options,
                    TableKey: "tool-table",
                    TableRows: TableRows,
                }))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
            }));
        }))));
    })))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

export function ToolsOverview(props) {
    let elems;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const toolsData = SWR_getTools();
    const labels = SWR_getLabels();
    const states = SWR_getStates();
    const showCreateInventoryTour = isCreateInventoryOnboardingTourOverviewPhase() && !props.State.OnboardingTourJoyrideDismissed;
    const showAssignToolsTour = isAssignToolsOnboardingTourTablePhase() && !props.State.OnboardingTourJoyrideDismissed;
    const showFilterSearchTour = isFilterSearchOnboardingTourTablePhase() && !props.State.OnboardingTourJoyrideDismissed;
    const errors = exists((error) => (error != null), ofArray([toolsData.error, labels.error, states.error]));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems = toList(delay(() => {
        let xs_4;
        if (errors) {
            return singleton(createElement(Skeleton, {
                Variant: "table",
            }));
        }
        else {
            const matchValue = toolsData.data;
            const matchValue_1 = labels.data;
            const matchValue_2 = states.data;
            const matchValue_3 = props.State.Storages;
            const matchValue_4 = props.State.Locations;
            const matchValue_5 = props.State.PropertyConfigurations;
            const matchValue_6 = props.State.CustomerConfiguration;
            const matchValue_7 = props.State.AccountSettings;
            const matchValue_8 = props.State.ReservationNames;
            let matchResult, accountSettings_2, customerConfiguration, labels_1, locations, propertyConfigurations, reservationNames, states_1, storages, tools;
            if (matchValue == null) {
                matchResult = 1;
            }
            else if (matchValue_1 == null) {
                matchResult = 1;
            }
            else if (matchValue_2 == null) {
                matchResult = 1;
            }
            else if (matchValue_3.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_4.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_5.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_6.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_7.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_8.tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                accountSettings_2 = matchValue_7.fields[0];
                customerConfiguration = matchValue_6.fields[0];
                labels_1 = matchValue_1;
                locations = matchValue_4.fields[0];
                propertyConfigurations = matchValue_5.fields[0];
                reservationNames = matchValue_8.fields[0];
                states_1 = matchValue_2;
                storages = matchValue_3.fields[0];
                tools = matchValue;
            }
            switch (matchResult) {
                case 0:
                    return singleton((xs_4 = toList(delay(() => append(singleton(createElement(ToolsOverviewTable, {
                        AccountSettings: accountSettings_2,
                        CallMutate: () => {
                            toolsData.mutate();
                        },
                        CurrentUser: props.CurrentUser,
                        CustomerConfiguration: customerConfiguration,
                        Definitions: states_1.States,
                        Dispatch: props.Dispatch,
                        Labels: labels_1,
                        Locations: locations,
                        MutateDefinitions: () => {
                            states.mutate();
                        },
                        PropertyConfigurations: propertyConfigurations,
                        ReservationNames: reservationNames,
                        State: props.State,
                        Storages: storages,
                        Tools: tools,
                        UserData: props.State.UserData,
                    })), delay(() => {
                        let Steps;
                        return append(showCreateInventoryTour ? singleton(createElement(TourGuide, (Steps = singleton_1(new TourStep("[data-test-id=\'add-new-inventory-button\']", t("onboarding.tour.create_inventory_button_title"), reactElement("div", {
                            children: t("onboarding.tour.create_inventory_button_content"),
                        }), "bottom", false)), {
                            IsRunning: true,
                            Locale: new TourGuideLocale(t("onboarding.tour.joyride_back"), t("onboarding.tour.joyride_close"), t("onboarding.tour.joyride_last"), t("onboarding.tour.joyride_next"), t("onboarding.tour.joyride_next_with_progress"), t("onboarding.tour.joyride_open"), t("onboarding.tour.joyride_skip")),
                            OnFinish: () => {
                                props.Dispatch(new Msg(10, []));
                            },
                            OnSkip: () => {
                                props.Dispatch(new Msg(9, []));
                            },
                            ScrollFirstStep: false,
                            Steps: Steps,
                        }))) : empty(), delay(() => {
                            let Steps_1;
                            return append(showAssignToolsTour ? singleton(createElement(TourGuide, (Steps_1 = singleton_1(new TourStep("[data-test-id=\'tools-overview-inventory-table\']", t("onboarding.tour.assign_tools_table_title"), reactElement("div", {
                                children: t("onboarding.tour.assign_tools_table_content"),
                            }), "top", true)), {
                                IsRunning: true,
                                Locale: new TourGuideLocale(t("onboarding.tour.joyride_back"), t("onboarding.tour.joyride_close"), t("onboarding.tour.joyride_last"), t("onboarding.tour.joyride_next"), t("onboarding.tour.joyride_next_with_progress"), t("onboarding.tour.joyride_open"), t("onboarding.tour.joyride_skip")),
                                OnFinish: () => {
                                    props.Dispatch(new Msg(10, []));
                                },
                                OnSkip: () => {
                                    props.Dispatch(new Msg(9, []));
                                },
                                ScrollFirstStep: true,
                                Steps: Steps_1,
                            }))) : empty(), delay(() => {
                                let Steps_2;
                                return append(showFilterSearchTour ? singleton(createElement(TourGuide, (Steps_2 = singleton_1(new TourStep("[data-test-id=\'tools-overview-inventory-table\']", t("onboarding.tour.filter_search_table_title"), reactElement("div", {
                                    children: t("onboarding.tour.filter_search_table_content"),
                                }), "top", true)), {
                                    IsRunning: true,
                                    Locale: new TourGuideLocale(t("onboarding.tour.joyride_back"), t("onboarding.tour.joyride_close"), t("onboarding.tour.joyride_last"), t("onboarding.tour.joyride_next"), t("onboarding.tour.joyride_next_with_progress"), t("onboarding.tour.joyride_open"), t("onboarding.tour.joyride_skip")),
                                    OnFinish: () => {
                                        props.Dispatch(new Msg(10, []));
                                    },
                                    OnSkip: () => {
                                        props.Dispatch(new Msg(9, []));
                                    },
                                    ScrollFirstStep: true,
                                    Steps: Steps_2,
                                }))) : empty(), delay(() => {
                                    let Steps_3;
                                    return (((accountSettings_2.SetsEnabled && Permissions_has(permissions, new Permission(1, []))) && isSetBundlesTourOverviewPhase()) && !props.State.OnboardingTourJoyrideDismissed) ? singleton(createElement(TourGuide, (Steps_3 = singleton_1(new TourStep("[data-test-id=\'add-new-set-button\']", t("onboarding.tour.sets_overview_create_title"), reactElement("div", {
                                        children: t("onboarding.tour.sets_overview_create_content"),
                                    }), "bottom", true)), {
                                        IsRunning: true,
                                        Locale: new TourGuideLocale(t("onboarding.tour.joyride_back"), t("onboarding.tour.joyride_close"), t("onboarding.tour.joyride_last"), t("onboarding.tour.joyride_next"), t("onboarding.tour.joyride_next_with_progress"), t("onboarding.tour.joyride_open"), t("onboarding.tour.joyride_skip")),
                                        OnFinish: () => {
                                            props.Dispatch(new Msg(9, []));
                                        },
                                        OnSkip: () => {
                                            props.Dispatch(new Msg(9, []));
                                        },
                                        ScrollFirstStep: true,
                                        Steps: Steps_3,
                                    }))) : empty();
                                }));
                            }));
                        }));
                    })))), react.createElement(react.Fragment, {}, ...xs_4)));
                default:
                    return singleton(createElement(Skeleton, {
                        Variant: "table",
                    }));
            }
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function OverviewView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => init_1(tupledArg[0], tupledArg[1]), update_1, (_arg, _arg_1) => {
    }), [props.UserData, usePermissions()], undefined);
    return createElement(ToolsOverview, {
        CurrentUser: props.CurrentUser,
        Dispatch: patternInput[1],
        State: patternInput[0],
    });
}

